// extracted by mini-css-extract-plugin
export var bar = "Pips-module--bar--98214";
export var button = "Pips-module--button--64614";
export var isHorizontal = "Pips-module--isHorizontal--89052";
export var isVertical = "Pips-module--isVertical--240bf";
export var isWhiteOut = "Pips-module--isWhiteOut--e1054";
export var item = "Pips-module--item--05cf8";
export var pip = "Pips-module--pip--125af";
export var pips = "Pips-module--pips--cc544";